/**
 * Date型から00:00に変換
 */
export const convertTimeHHMM = (date: Date): string => {
  const HH = `${date.getHours()}`.padStart(2, "0");
  const MM = `${date.getMinutes()}`.padStart(2, "0");
  return `${HH}:${MM}`;
};
